const ABProcessTriggerTimerCore = require("../../../core/process/tasks/ABProcessTriggerTimerCore");
module.exports = class ABProcessTriggerTimer extends (
   ABProcessTriggerTimerCore
) {};
